import { IP_NOTICE_LONG } from '../legal/ipNotice';

export default function LegalPage() {
  return (
    <main className="page legal-page">
      <h1>IP & Independence</h1>
      {IP_NOTICE_LONG.split("\n\n").map((p, i) => (
        <p key={i}>{p}</p>
      ))}
      <p>
        Last updated: {new Date().toLocaleDateString("en-GB")}
      </p>
    </main>
  );
}
